module.exports = new __parcel__URL__("meteogramme.d5d95ae7.svg").toString();